<template>
    <v-container>
        <div class="d-flex flex-column justify-space-between align-center">
            <v-img
            :src="require('../assets/check-icon.png')"
            class="my-10"
            contain
            height="156"
            width="156"
            />
            <h1>Thank You!</h1>
            <p></p>
            <h1>Payment Sucessful</h1>
            <p></p>
            <h3 style="color: #962283" class="display-0 font-weight-bold mb-1">
                Your Reference is:
            </h3>
            <p></p>
            <h3>{{charge_token}}</h3>
            <p></p>
            <h3 style="color: #962283" class="display-0 font-weight-bold mb-1">
                Click View My Tickets to see Tickets
            </h3>
        </div>
    </v-container>
</template>

<script>
import db from "../data/Database";
export default {
  data() {
    return {
      charge_token: null,
      currentState: null,
    };
  },
  created() {
    // const queryString = window.location.search;
    // const urlParams = new URLSearchParams(queryString);
    // this.charge_token = urlParams.get('charge_token')
    this.charge_token = this.$route.params.charge_token;
    db.currentState.get(1, (result) => this.loadState(result));
  },
  methods: {
    loadState(result) {
        this.currentState = result;
    },
  },
  computed: {},
};
</script>

<style lang="scss" scoped>

</style>